import t from './story01.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,

  prose: [
    // Run 1 — the open, no heading.
    [
      {
        text: t.s1P1,
      },
      {
        text: t.s1P2,
      },
      {
        text: t.s1P3,
      },
      {
        text: t.s1P4,
      },
    ],
    // Run 2 — first themed section.
    [
      {
        title: t.s2Title,
        text: t.s2P1,
      },
    ],
    // Run 3 — continues after the Boye pull quote.
    [
      {
        text: t.s3P1,
      },
      {
        text: t.s3P2,
      },
    ],
    // Run 4 — second themed section.
    [
      {
        title: t.s4Title,
        text: t.s4P1,
      },
      {
        text: t.s4P2,
      },
      {
        text: t.s4P3,
      },
    ],
    // Run 5 — continues after the Akyem Adukrom figure.
    [
      {
        text: t.s5P1,
      },
    ],
    // Run 6 — third themed section.
    [
      {
        title: t.s6Title,
        text: t.s6P1,
      },
      {
        text: t.s6P2,
      },
      {
        text: t.s6P3,
      },
      {
        text: t.s6P4,
      },
      {
        text: t.s6P5,
      },
    ],
    // Run 7 — fourth themed section.
    [
      {
        title: t.s7Title,
        text: t.s7P1,
      },
    ],
    // Run 8 — continues after the second Akyem Adukrom figure.
    [
      {
        text: t.s8P1,
      },
      {
        text: t.s8P2,
      },
      {
        text: t.s8P3,
      },
      {
        text: t.s8P4,
      },
      {
        text: t.s8P5,
      },
      {
        text: t.s8P6,
      },
    ],
    // Run 9 — fifth themed section.
    [
      {
        title: t.s9Title,
        text: t.s9P1,
      },
      {
        text: t.s9P2,
      },
    ],
    // Run 10 — continues after the Boateng pull quote.
    [
      {
        text: t.s10P1,
      },
    ],
    // Run 11 — sixth themed section.
    [
      {
        title: t.s11Title,
        text: t.s11P1,
      },
      {
        text: t.s11P2,
      },
      {
        text: t.s11P3,
      },
      {
        text: t.s11P4,
      },
      {
        text: t.s11P5,
      },
    ],
    // Run 12 — continues after the Birim River figure.
    [
      {
        text: t.s12P1,
      },
    ],
    // Run 13 — the close.
    [
      {
        title: t.s13Title,
        text: t.s13P1,
      },
      {
        text: t.s13P2,
      },
      {
        text: t.s13P3,
      },
    ],
  ],

  captions: [
    // 01 — hero, the silted Birim River.
    [t.f1P1],
    // 02 — the mining site at Akyem Adukrom.
    [t.f2P1],
    // 03 — work under way at the same site.
    [t.f3P1],
    // 04 — another polluted stretch of the Birim.
    [t.f4P1],
    // 05 — the Birim at Anyinam, from the air.
    [t.f5P1],
  ],

  // Pull quotes, in the order they interrupt the body. The quotation marks belong
  // to the copy, so they're authored here rather than added by the component.
  quotes: [
    {
      text: t.q1,
      attribution: t.q1Attr,
    },
    {
      text: t.q2,
      attribution: t.q2Attr,
    },
  ],
} as const
